module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Import-d3e1a7c2e318f923d9696f57889f8891.svg";